import { Box } from '@mui/material';
import { Suspense } from 'react';

import {
  useCreateOrUpdatePipeline,
  usePipelineFormHandler,
} from '@pages/common/Administrator/Pipeline/hooks';
import {
  PipelineForm,
  PipelineHeader,
} from '@pages/common/Administrator/Pipeline/components';
import { usePipelineFormContext } from '@pages/common/Administrator/Pipeline/usePipelineFormContext';
import { HeaderElement } from '@/pages/common/Patient/StyledComponents';
import LoadingState from '@/components/LoadingState';

const ViewPipeline = () => {
  const { dataPipeline } = usePipelineFormContext();
  const mainPipelineID = dataPipeline ? dataPipeline.mainPipelineID : '';

  const {
    handleSubmit,
    register,
    control,
    mode,
    pipelineId,
    formState: { errors, isSubmitting },
  } = usePipelineFormHandler({ mainPipelineID });

  const onSubmit = useCreateOrUpdatePipeline(mode, pipelineId);

  return (
    <Box
      sx={{ width: '100%', maxWidth: 1440, mx: 'auto', p: { xs: 2, md: 3 } }}
    >
      <HeaderElement onSubmit={handleSubmit(onSubmit)}>
        <PipelineHeader control={control} isSubmitting={isSubmitting} />
        <input
          type="text"
          hidden
          defaultValue={mainPipelineID || 'main'}
          {...register('main_pipelineID')}
        />
        <PipelineForm
          mode={mode}
          register={register}
          control={control}
          errors={errors}
          mainPipelineID={mainPipelineID}
        />
      </HeaderElement>
    </Box>
  );
};

const PipelineWithSuspense = () => (
  <Suspense fallback={<LoadingState label="Loading pipeline…" />}>
    <ViewPipeline />
  </Suspense>
);

export default PipelineWithSuspense;
